export const permissions = {
  dashboard: {
    oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
  },
  catalog: {
    oneOf: ["CREATE_CATALOG"]
  },
  attribute: {
    required: ["CREATE_ATTRIBUTE"]
  },
  item: {
    oneOf: ["VIEW_ITEM", "VIEW_ALL_ITEMS"]
  },
  partner: {
    required: ["CREATE_PARTNER"]
  },
  role: {
    required: ["CREATE_ROLE"]
  },
  permission: {
    required: ["CREATE_PERMISSION"]
  },
  tenant: {
    required: ["CREATE_TENANT"]
  },
  sub_tenant: {
    required: ["CREATE_ADMIN"]
  },
  inventory: {
    oneOf: ["CREATE_INVENTORY", "LOAD_INVENTORY", "TRANSFER_INVENTORY"]
  },
  serviceRequest: {
    oneOf: ["SERVICE_REQUEST"]
  },
  office_org: {
    oneOf: ["ORG_HIERARCHY"]
  },
  suboffice_org: {
    oneOf: ["SUB_OFFICE_HIERARCHY"]
  },
  service_ticket: {
    oneOf: ["SERVICE_TICKET"]
  },
  orders_management: {
    oneOf: ["MANAGE_ORDERS"]
  },
  commission: {
    oneOf: ["COMMISSION"]
  },
  discount_coupons: {
    oneOf: ["DISCOUNT_COUPONS"]
  },
  subscription: {
    oneOf: ["CREATE_SUBSCRIPTION"]
  },
  accessrule: {
    oneOf: ["CREATE_ACCESS_RULE"]
  },
  deliverysetup: {
    oneOf: ["CREATE_DELIVERY_SETUP"]
  },
  offerImage: {
    oneOf: ["OFFER_IMAGE"]
  },
  promotion: {
    oneOf: ["MANAGE_PROMOTION"]
  },
  manage_team: {
    oneOf: ["MANAGE_TEAM"]
  },
  faq: {
    oneOf: ["READ_FAQ"]
  },
  setup: {
    oneOf: ["CREATE_SETUP"]
  },
  taxcodeSetup: {
    oneOf: ["CREATE_TAXCODE"]
  },
  concern: {
    oneOf: ["TENANT_DASH"]
  },
  Resources: {
    oneOf: ["TENANT_DASH"]
  },
  couponSetup: {
    oneOf: ["CREATE_COUPON"]
  },
  serviceRequestSetup: {
    oneOf: ["CREATE_SERVICEREQUEST_SETUP"]
  },
  commissionSetup: {
    oneOf: ["CREATE_COMMISSION_SETUP"]
  },
  FAQSetup: {
    oneOf: ["CREATE_FAQ_SETUP"]
  },
  advertisement: {
    oneOf: ["CREATE_ADVERTISEMENT", "ADVERTISEMENT_CREATE"]
  },
  customer: {
    oneOf: ["CUSTOMER_EXPORT"]
  },
  payment_history: {
    oneOf: ["PAYMENT_RECORD"]
  },
  approval: {
    oneOf: ["MANAGE_APPROVAL"]
  },
  manage_own_customer:{
    oneOf: ["MANAGE_OWN_CUSTOMER"]
   },
  templateCreation:{
    oneOf: ["CREATE_TAXCODE"]
   },
  approvalNotification:{
    oneOf: ["LIST_BULK_NOTIFICATION"]
   },
  bulkNotification:{
    oneOf: ["LIST_CRITERIA"]
   },
};
